/**
 * @generated SignedSource<<9dc7209757db0f7ca7e507e7ea199fa9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotoView_query$data = {
  readonly currentUser: {
    readonly rowId: any;
  } | null | undefined;
  readonly " $fragmentType": "PhotoView_query";
};
export type PhotoView_query$key = {
  readonly " $data"?: PhotoView_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotoView_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotoView_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8fb858d2c156086a6e6f67f53dd5b2a2";

export default node;
